import { render, staticRenderFns } from "./dismissedSuggestion.vue?vue&type=template&id=14e14697"
import script from "./dismissedSuggestion.vue?vue&type=script&lang=js"
export * from "./dismissedSuggestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports